import React, { useEffect, useState , useRef , useCallback, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useLocation , useNavigate } from "react-router-dom";
import { Alert } from '@mui/material';
import { Modal, Snackbar } from '@mui/material';
import COLOR from 'utils/constants/color';
import Calendar from 'features/Calendar';
import ChapterManagementBook from 'features/ChapterManagementBook';
import CotationLoader from 'components/CotationLoader';
import DashboardHeader from 'modules/StudentDashboardNew/DashboardHeader';
import LoadingWrapper from 'components/LoadingWrapper';
import SentryWrap from 'components/Sentry';
import StudentDashboardHomeSkeletonPage from 'pages/StudentDashboardHomeSkeletonPage';
import StudentVisuals from 'features/StudentVisuals';
import WelcomeVideo from 'components/WelcomeVideo';
import{ filter,  uniqBy,   get , has } from 'lodash';
import queryString from 'query-string';
import styled from 'styled-components';
import { getCurrentUser } from 'aws-amplify/auth';
import { Col , Row } from 'antd';
import { EyeFilled } from '@ant-design/icons';
import { handleListActivities, handleListCustomAssignment } from 'store/activities/thunks';
import { handleListClassActivitiesForStudent } from 'store/classActivities/thunks';
import { handleListClassBookmarks } from 'store/bookmark/thunks';
import { handleListClassQuizzesForStudent } from 'store/classQuizzes/thunks';
import { handleListQuizzes } from 'store/quizzes/thunks';
import { handleListUserBooks } from 'store/userBooks/thunks';
import { handleListUserSubmissionsByClass } from 'store/submissions/thunks';
import { makeStyles } from 'utils/styles/mui';
import { useClassGameActivity } from 'store/one_game/selectors';
import { useDemoStatus } from 'store/users/selectors';
import { useFullScreenTabDetect } from 'containers/chat/hooks';
import useMobileDeviceDetection, { useIsMobileDevice, useTabletDetection } from './chat/hooks';
import { getRandomCotation } from "utils/methods/math"
import AssignmentList from "components/AssignmentLists"
import { useUI } from 'store/UI/selectors';
import { useWelcomeVideos } from 'store/welcomeVideo/selectors';
import { handleGetWelcomeVideos } from 'store/welcomeVideo/thunks';
import useActiveStudentofParent from 'components/hooks/parent/activeStudentofParent';
import { handleSetClassAiConfigEnabled } from 'store/users/thunks';
import { useClassBooks } from 'components/hooks/books/useClassBooks';
import myAssignSvg from "../utils/assets/images/my-assign.svg";

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------


const ButtonClear = styled.button`
    background-color: transparent;
    border: none;
    // color: ${COLOR.black600};
    cursor: pointer;
    outline: none;
    padding: 0px;
`;


const Container = styled.div`
    // padding: 24px 0px;
`;

const Section = styled.div`
    margin-bottom: 64px;
    width: 100%;

    &:first-child {
        margin-bottom: 24px;
    }
`;

const SectionHeader = styled.span`
    border-bottom: 1px dashed ${COLOR.black800};
    color: ${COLOR.black300};
    display: block;
    font-size: 11px;
    font-weight 600;
    margin-bottom: 16px;
    padding-bottom: 4px;
    text-transform: uppercase;
     visibility: hidden;
`;
const MyAssinContainer = styled.span`
    color: #10979D;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.64px;
`;


const VideoContainer = styled.div`
    height: auto;
    flex: 1;
    justify-content: center;
`;


const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    root: {
        '& > *': {
            margin: '2px',
        },
    }
}));

//  ----------------------------------------------------------------------------
//  Container
//  ----------------------------------------------------------------------------
//
//  Student dashboard container
//
//  -- Description
//  Student class view. Contains current class data (grades, assignments submitted,
//  etc.), upcoming assignments and class communication.
//
//  -- Props
//  classActivities {array} - list of activities assigned to current class
//  classQuizzes {array} - list of quizzes assigned to current class
//  currentClass {object} - selected class
//  currentUser {object} - current authenticated user
//  submissions {array} - list of student assignment submissions
//
const getTab = (key = "") => {
    switch (key) {
        case 'home':
            return key;
        case 'assessments':
            return key;
        case 'studentData':
            return key;
        default:
            return "home";
    }
}

const StudentDashboard = ({
    classActivities,
    classQuizzes,
    currentClass,
    currentUser,
    submissions,
    booksAllList,
    activities,
    quizzes,
    userPreference
    
}) => {
    const deviceType = useMobileDeviceDetection();
    const { fetchClassGameActivity } = useClassGameActivity()
    const classes = useStyles();
    const location = useLocation();
    const navigate = useNavigate();
    const welcomeVideo = useWelcomeVideos();
    const searchParams = useMemo(() => {
        return queryString.parse(location.search);
    }, [location.search]);
    const searchView = useMemo(() => {
        return getTab(searchParams.view || "home");
    }, [searchParams.view]);
    const search = queryString.parse(location.search);
    const dispatch = useDispatch();
    const [searchAssignment, setSearchAssignment] = useState('');
    const [loading, setLoadingFlag] = useState(true);
    const [cotationLoader, setCotationLoader] = useState(true);
    const [modalOpen, setModalState] = useState(false);
    const cotationRef = useRef(null)
    const [popupMessage, setPopupMessage] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const demoStatus = useDemoStatus();
    const isTabletFull = useFullScreenTabDetect();
    const tab = useTabletDetection();
    const mobile = useIsMobileDevice();
    const { class_game_activity } = useClassGameActivity()
    const [isExpandStudent, setIsExpandStudent] = useState(() => {
        const saved = localStorage.getItem('isExpandStudent');
        return saved === 'true'; // Convert string to boolean
    });
    const dataRef = useRef();
    const { activeStudentParent } = useActiveStudentofParent();
      const { quotesData = [] } = useUI();
    const { loading: classBooksLoading , fetchClassBooks } = useClassBooks()

    const handleSearch = (val) => {
    // do search logic
    // trigger something in DataComponent
    dataRef.current?.applyAllFiltersAndSort(undefined, undefined, undefined, val);
  };

    const getWelcomeVideoUrl = async () => {
        if (!welcomeVideo?.id) {
            await dispatch(handleGetWelcomeVideos());
        }
    }
    useEffect(() => {
        getWelcomeVideoUrl();
    }, []);

    useEffect(() => {
        localStorage.setItem('isExpandStudent', isExpandStudent);
    }, [isExpandStudent]);

 

    if (!cotationRef.current) {
        cotationRef.current = getRandomCotation(quotesData)
    }

    useEffect(() => {
        const body = document.querySelector('body');
        if (body) body.scrollTop = 0;
        //console.log("Scrolled to top on", location.pathname + location.search);
    }, [location.key]);

    useEffect(() => {
        if (searchView == "assessments" || searchView == "studentData") {
            listCurrentClassInfo()
            listAllAssignments()
        }
    }, [searchView])
    useEffect(() => {
        async function fetchData() {
            try {
                await getCurrentUser();
            } catch {
                navigate('/');
            }
        }
        fetchData();
    }, []);
    const listAllAssignments = async () => {
        return;
        if (!Array.isArray(activities) || activities.length == 0) {
            await dispatch(handleListActivities());
        }

        if (!Array.isArray(quizzes) || quizzes.length == 0) {
            await dispatch(handleListQuizzes());
        }
        await dispatch(handleListCustomAssignment(get(currentUser, "role"), get(currentUser, "id")))
    }

    const listCurrentClassInfo = async () => {
        if (has(currentClass, "id")) {
            dispatch(handleListClassActivitiesForStudent(get(currentClass, "id"), get(currentUser, "id")));
            dispatch(handleListClassQuizzesForStudent(get(currentClass, "id"), get(currentUser, "id")));
        }
    }
    const getUserSubmissions = async () => {
        // dispatch(handleListUserSubmissions(currentUser?.id))
        await dispatch(handleListUserSubmissionsByClass(currentUser?.id, currentClass?.id))
    }
    const listAllBooks = async () => {
        if (!booksAllList || booksAllList.length == 0) {
            await fetchClassBooks();
        }
    }
    const listClassBookmark = async () => {
        if (has(currentClass, "id")) {
            dispatch(handleListClassBookmarks(currentClass.id))
        }
    }
    const fetchAllData = async () => {
        setLoadingFlag(true);
        setCotationLoader(true)
        let currentClassId = localStorage.getItem("currentClassId")
        if ((currentClassId && (currentClassId === currentClass?.id || currentClassId === "nocurrentuser"))) {
            setLoadingFlag(false)
            setCotationLoader(false)
        }
        await Promise.allSettled([
            listCurrentClassInfo(),
            getUserSubmissions(),
            listAllBooks(),
            listClassBookmark(),
            fetchClassGameActivity()

        ])
        localStorage.setItem("currentClassId", currentClass?.id ?? "nocurrentuser")
        setLoadingFlag(false);
        setCotationLoader(false)
        dispatch(handleListUserBooks(currentUser?.id))
        dispatch(handleSetClassAiConfigEnabled(get(currentClass, "id")));
    }

    useEffect(() => {
        fetchAllData();
        if(has(currentClass,"id")&&currentClass.archived){
            // history.goBack();
        }
    }, [currentClass, currentUser, activeStudentParent]);


    useEffect(() => {
        if (!cotationLoader) {
            setModalState(true);
        }
    }, [currentUser, cotationLoader]);




    const handleCloseVideo = (() => {
        currentUser.newUser = false;
        setModalState(false);
    });

    const allGraded = filter(submissions, x => x?.graded);

    const getAssignment = useCallback(() => {
        const uniqueActivity = uniqBy(classActivities, "activityId");
        const uniqueQuiz = uniqBy(classQuizzes, 'quizId')
        const worksheet_game = Array.isArray(class_game_activity) ? class_game_activity?.filter(k => k.type == "worksheet") : []

        return [...uniqueActivity, ...uniqueQuiz, ...worksheet_game]
    }, [classActivities, classQuizzes, class_game_activity])

    const handleTabs = (key) => {
        switch (key) {
            case 'home':
                navigate('/student/class?view=home');
                fetchAllData();
                break;
            case 'assessments':
                navigate('/student/class?view=assessments');
                fetchAllData();
                break;
            case 'studentData':
                navigate('/student/class?view=studentData');
                break;
            default:
                break;
        }
    }

    const openAccessDenineMessage = () => {
        setOpen(true)
        setPopupMessage('Restricted access (legend)')
    }
    const onWayTeacher = () => {
        if (demoStatus) {
            openAccessDenineMessage()
        } else {
            navigate('/Strategies')
        }
    }
    const handleClose = () => {
        setOpen(false);
    };

    const assignmentRef = useRef(null);
    const prevExpand = useRef(isExpandStudent);
    useEffect(() => {
        if (prevExpand.current && !isExpandStudent && assignmentRef.current) {
            // Only scroll when isExpandStudent changes from true to false
            if (window.innerWidth <= 1228) {
                setTimeout(() => {
                    assignmentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 100);
            }
        }
        prevExpand.current = isExpandStudent;
    }, [isExpandStudent]);

    const handleExpandClick = () => {
        setIsExpandStudent(!isExpandStudent);
    };

    return (
        <SentryWrap>
            <Modal
                className={classes.modal}
                open={cotationLoader || classBooksLoading}
            >
                <VideoContainer>
                    <CotationLoader cotation={cotationRef.current} />
                </VideoContainer>
            </Modal>

            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}>
                <Alert onClose={handleClose} severity="error">
                    <strong>ALERT:</strong> {popupMessage}
                </Alert>
            </Snackbar>
            <WelcomeVideo open={modalOpen} onClose={handleCloseVideo} welcomeVideo={welcomeVideo} />
            <DashboardHeader handleTabs={handleTabs} searchAssignment={searchAssignment} onSearchChange={handleSearch} />
            <Row>
                <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                    <Container>
                        <Row className="tabCollection wrapperAdmnDash wrapperAdmnAddOn">
                            <Col className="contentAdmnDash"
                                style={{ flex: deviceType ? 1 : "revert-layer", minWidth: deviceType ? "100%" : undefined }}
                                xs={{ span: 24 }} sm={24}
                                xl={{
                                    span: searchView === "home"
                                        ? (isExpandStudent ? 24 : 17)
                                        : 24
                                }}
                                lg={{ span: searchView == "home" ? "" : (!searchView) ? 17 : 24 }}
                            >

                                {searchView == 'home' && (
                                    <>
                                        <Section
                                            description="Below are the chapters for the book. Clicking on a chapter will display the book."
                                            header='Home'
                                        >
                                            {loading ? (
                                                <StudentDashboardHomeSkeletonPage />
                                            ) : (
                                                <SentryWrap>
                                                    <ChapterManagementBook />
                                                </SentryWrap>
                                            )}
                                        </Section>
                                    </>
                                )}
                                {searchView == 'assessments' && (
                                    <>
                                        <Section>
                                            <SectionHeader>My Calendar</SectionHeader>
                                            <LoadingWrapper loading={loading}>
                                                <SentryWrap>
                                                    <Calendar
                                                        assignments={getAssignment()}
                                                        submissions={submissions}
                                                        booksAllList={booksAllList}
                                                        currentUser={currentUser}
                                                        userBooks={[]}
                                                        userPreference={userPreference}
                                                    />
                                                </SentryWrap>
                                            </LoadingWrapper>
                                        </Section>
                                    </>
                                )}

                                {searchView == 'studentData' && (
                                    <>
                                        <Section>
                                            <LoadingWrapper loading={loading}>
                                                <SentryWrap>
                                                    <StudentVisuals
                                                        ref={dataRef} 
                                                        assignments={getAssignment()}
                                                        searchAssignment={searchAssignment}
                                                    />
                                                </SentryWrap>
                                            </LoadingWrapper>
                                        </Section>
                                    </>
                                )}
                                
                            </Col>
                            {searchView == "home" && (
                                !(mobile || tab || isTabletFull) ? (
                                    <div onClick={handleExpandClick} style={{ position: "absolute", right: -5, top: 0, padding: "2px 5px", borderRadius: 30, cursor: "pointer", zIndex: 99 }}>
                                        {isExpandStudent &&
                                            <MyAssinContainer>
                                                My Assignments {" "}
                                                <img src={myAssignSvg} alt="" />
                                            </MyAssinContainer>
                                        }
                                    </div>
                                ) : ''
                            )}
                            {!isExpandStudent && searchView === "home" && (
                                <Col
                                    ref={assignmentRef}
                                    className="sidebarAdmnDash assignment-list-dashboard"
                                    xs={{ span: 24 }}
                                    sm={24}
                                    lg={{ span: search.view !== "home" ? 7 : undefined }}
                                    xl={{ span: search.view === "home" && 7 }}
                                    style={{ minWidth: deviceType ? "100%" : undefined }}
                                >
                                    <div
                                        className="assignmentListSection 1212"
                                        style={{ display: deviceType ? 'none' : 'inherit' }}
                                    >
                                        <AssignmentList
                                            headerChild={
                                                !(mobile || tab || isTabletFull) ? (
                                                    <EyeFilled
                                                        onClick={() => setIsExpandStudent(prev => !prev)}
                                                        style={{
                                                            fontSize: 22,
                                                            cursor: "pointer",
                                                            marginLeft: 8,
                                                        }}
                                                    />
                                                ) : ''
                                            }
                                        />
                                    </div>
                                </Col>
                            )}

                            {/* {{!isExpandStudent && (

                                (searchView == "home") && <Col className="sidebarAdmnDash assignment-list-dashboard" xs={{ span: 24 }} sm={24} lg={{ span: search.view != "home" && 7 }} xl={{ span: search.view == "home" && 7 }} style={{ minWidth: deviceType ? "100%" : undefined }}>
                                <div className="assignmentListSection" style={{display:deviceType ? 'none' : 'inherit'}}>
                                    <AssignmentList headerChild={window.innerWidth >= 1200 ? <EyeFilled onClick={() => setIsExpandStudent(!isExpandStudent)} style={{ fontSize: 22, cursor: "pointer", marginLeft: 8 }} /> : ''} />
                                </div>
                            </Col>)} */}
                        </Row>
                    </Container>
                </Col>
            </Row>
        </SentryWrap>
    );
};



//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = state => ({
    classActivities: state.classActivities,
    classQuizzes: state.classQuizzes,
    currentClass: state.currentClass,
    currentUser: state.currentUser,
    submissions: state.submissions,
    booksAllList: state.booksAllList,
    userClasses: state.userClasses,
    activities: state.activities,
    quizzes: state.quizzes,
    userPreference: state.userPreference
});

export default connect(mapStateToProps, null)(StudentDashboard);